<script setup>
import { defineModel, defineProps } from 'vue'

const model = defineModel()
const props = defineProps({
    isError: {
        type: Boolean,
        default: false,
        required: true
    },
    type: {
        type: String,
        default: 'text',
        required: true
    },
    isDisabled: {
        type: Boolean,
        default: false,
        required: true
    },
    isRequired: {
        type: Boolean,
        default: true,
        required: true
    },
    isDisabledLabelActive: {
        type: Boolean,
        default: false,
        required: true
    }
})
</script>

<template>
    <div class="flex flex-col">
        <div class="h-12 border rounded-sm bg-transparent relative outline-none flex items-center px-4"
             :class="{
            'border-gray-400': props.isDisabled,
            'border-black': !props.isError,
            'border-red-600': props.isError && !props.isDisabled,
         }"
        >
            <input
                v-model="model"
                :type="props.type"
                class="w-full h-full outline-none bg-transparent"
                :disabled="props.isDisabled"
            >
            <div class="text-xs absolute -top-2 left-5 bg-gray-100 px-2 rounded-full select-none"
                 :class="{
                    'text-red-600': props.isError && !props.isDisabled,
                 }"
            >
                Значение
            </div>
        </div>
        <div v-if="props.isError && !props.isDisabled" class="text-xs select-none text-red-600 mt-1">
            Введите значение
        </div>
        <div v-if="!props.isRequired" class="text-xs select-none mt-1">
            <div class="">При данном условии значение игнорируется</div>
        </div>
        <div v-if="isDisabledLabelActive" class="text-xs select-none mt-1">
            Сперва выберите условие
        </div>
    </div>


</template>

<style scoped>

</style>